module.exports = __webpack_public_path__ + "img/patient-question.f1a17224.svg";